import { Injectable, inject } from '@angular/core';
import { OverlayColor } from '@models';
import { RenderService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class PrecisionCuttingDrawService {
  private renderService = inject(RenderService);
  endPointsCircle = [0, 0];
  startPointsCircle = [0, 0];
  highlightedDot = 0;

  drawCutStart(
    width: number,
    height: number,
    center: number[],
    angleStart: number,
  ) {
    const a = width / 2;
    const b = height / 2;

    const xStart = center[0] - a * Math.cos(angleStart);
    const yStart = center[1] - b * Math.sin(angleStart);
    const angleRadians = (-90 * Math.PI) / 180;

    for (let i = 0; i < 7; i++) {
      const x =
        xStart +
        30 * i * Math.cos(angleRadians) +
        (i === 1 ? 15 : i > 1 ? 30 : 0);
      const y = yStart - 30 * i * Math.sin(angleRadians);
      this.renderService.addDynamic({
        overlay: {
          type: 'circle',
          x,
          y,
          radius: 6,
          fillColor: OverlayColor.blue,
          transparency: 0.3,
        },
      });
    }
  }

  drawEllipsePart(
    width: number,
    height: number,
    center: number[],
    angleStart: number,
    angleEnd: number,
    direction: 'cw' | 'ccw',
  ) {
    const a = width / 2;
    const b = height / 2;
    const xEnd = center[0] - a * Math.cos(angleEnd);
    const yEnd = center[1] - b * Math.sin(angleEnd);
    this.endPointsCircle = [xEnd, yEnd];

    const xStart = center[0] - a * Math.cos(angleStart);

    const yStart = center[1] - b * Math.sin(angleStart);
    this.startPointsCircle = [xStart, yStart];

    const numberOfDots = direction === 'cw' ? 10 : 13;

    this.highlightedDot =
      this.highlightedDot >= numberOfDots ? 0 : this.highlightedDot + 1;

    for (let i = 0; i < numberOfDots; i++) {
      const angle = angleStart + ((angleEnd - angleStart) * i) / numberOfDots;
      const x = center[0] - a * Math.cos(angle);
      const y = center[1] - b * Math.sin(angle);
      this.renderService.addDynamic({
        overlay: {
          type: 'circle',
          x,
          y,
          radius: 6,
          fillColor: OverlayColor.blue,
          transparency: i === this.highlightedDot ? 0.5 : 0.3,
        },
      });
    }
    this.renderService.addDynamic({
      overlay: {
        type: 'triangle',
        size: 24,
        angle: angleEnd,
        direction,
        x: this.endPointsCircle[0],
        y: this.endPointsCircle[1],
        fillColor: OverlayColor.blue,
        transparency: 0.3,
      },
    });
  }
}
